import cx from 'classnames';
import config from '@plone/registry';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Banner/styles.module.css';
import containerStyles from '@redturtle/qubicaamf-theme/components/Container/container.module.css';
import type { BannerData } from '@redturtle/qubicaamf-theme/components/Blocks/Banner/schema';

interface BannerProps {
  data: BannerData;
  editMode?: boolean;
}

const Banner = (props: BannerProps) => {
  const { data, editMode } = props;
  const Container = config.getComponent('Container').component || 'div';
  const Image = config.getComponent('Image').component;
  return (
    <div
      className={cx('banner', styles.banner, {
        [styles.smallBanner]: data.bannerSize === 'Small' || !data.bannerSize,
        [styles.largeBanner]: data.bannerSize === 'Large',
        [containerStyles.container]:
          (data.bannerSize === 'Small' || !data.bannerSize) &&
          !data.styles?.fullwidth,
      })}
    >
      <div className={styles.bannerImageContainer}>
        <Image
          item={data.bannerImage}
          className={styles.bannerImage}
          alt={data.bannerImage?.title ?? ''}
        />
        {data.showOverlay && <div className={styles.darkOverlay} />}
      </div>

      <Container
        className={cx(styles.blockBannerContainer, {
          [styles.editBlockBannerContainer]: editMode,
        })}
      >
        <div
          className={cx(styles.bannerText, {
            [styles.bannerTextNoOverlay]: !data.showOverlay,
          })}
        >
          <div className={styles.bannerTitleContainer}>
            {data.bannerTitleAsH1 ? (
              <h1 className={styles.bannerTitle}>{data.bannerTitle}</h1>
            ) : (
              <h2 className={styles.bannerTitle}>{data.bannerTitle}</h2>
            )}
          </div>
          <div className={styles.bannerDescriptionContainer}>
            <p className={styles.bannerDescription}>{data.bannerDescription}</p>
          </div>
          {data.linkHref?.[0] && (
            <CTA
              href={data.linkHref[0]['@id']}
              onClick={(e: React.SyntheticEvent<HTMLLinkElement>) => {
                if (editMode) {
                  e.preventDefault();
                }
              }}
              openLinkInNewTab={false}
              ctaButtonStyle={data.ctaButtonStyle}
              linkIcon={data.linkIcon}
              cta_color={data.cta_color}
            >
              {data.linkTitle}
            </CTA>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Banner;
